const ErrorStatusIcon = () => (
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4c8.8 0 16 7.2 16 16s-7.2 16-16 16S4 28.8 4 20 11.2 4 20 4Zm0-4C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0Zm2.8 20 5.6-5.6c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0L20 17.2l-5.6-5.6c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l5.6 5.6-5.6 5.6c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0l5.6-5.6 5.6 5.6c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8L22.8 20Z"
      fill="#F33"
    />
  </svg>
);

export default ErrorStatusIcon;
